<template>
  <teleport to="#modalTeleports">
    <div
      :class="[loadIframe ? 'w3-block' : '']"
      class="w3-modal"
      style="padding: 2vh; padding-top: 35px"
    >
      <div
        class="w3-modal-content w3-animate-top w3-center bg-transparent"
        style="width: 95vw"
      >
        <button
          class="w3-button w3-red w3-round w3-round-xxlarge absolute"
          style="top: -30px; right: 10px"
          @click.prevent="closeIframe('iframe')"
        >
          x
        </button>

        <iframe
          name="iframe"
          id="iframe"
          src=""
          style="width: 100%; height: 90vh; border: 0px solid #fff"
        ></iframe>
        <form @submit.prevent id="PaymentForm" method="POST">
          <input type="hidden" :value="uuid()" name="uuid" />
          <input type="hidden" name="ContactNo" v-model="ContactNo" />
          <input type="hidden" name="PhoneNo" v-model="PhoneNo" />
          <input type="hidden" name="Email" v-model="EMail" />
          <input type="hidden" name="Fullname" v-model="Fullname" />
          <input type="hidden" name="callback" value="gift" />
        </form>
      </div>
    </div>
  </teleport>
  <div class="relative mb-5 w3-white w3-border">
    <a
      href="javascript:;"
      @click="closeGiftForm"
      style="top: -10px"
      class="
        w3-button w3-orange
        hover-effect-tiny
        w3-border
        no-hover-underline
        btn-rounded
        absolute
        right-10
      "
    >
      x</a
    >
    <form
      @submit.prevent="Payment"
      id="SavingsPaymentForm"
      method="POST"
      style="max-width: 840px"
    >
      <input type="hidden" :value="uuid()" name="uuid" />
      <input type="hidden" name="ContactNo" v-model="ContactNo" />
      <input type="hidden" name="Email" v-model="EMail" />
      <input type="hidden" name="PhoneNo" v-model="PhoneNo" />
      <input type="hidden" name="Fullname" v-model="Fullname" />
      <input type="hidden" name="callback" value="gift" />
      <div
        v-show="activeStep === 'BenefProductCode'"
        data-step="BenefProductCode"
        class="steps"
      >
        <div class="row">
          <div class="col-md-6 pb-3">
            <div class="size15 w3-text-grey mb-0">Purchase a gift voucher</div>
            <h3 class="mt-0">Select a gift product</h3>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label size13">Investment</label>

              <div class="row equalHeightColumns">
                <div
                  v-for="product in Products"
                  :key="product.FundCode"
                  class="col-sm-6"
                >
                  <section
                    class="
                      card
                      column
                      hover-effect
                      cursor
                      mt-0
                      mb-2
                      w3-border w3-hover-border-red
                    "
                    :class="[
                      gift.BenefProductCode === product.FundCode
                        ? 'w3-red w3-text-white'
                        : 'w3-white',
                    ]"
                    @click="gift.BenefProductCode = product.FundCode"
                  >
                    <div class="card-body bg-transparent m-0 px-3 py-2">
                      <h3 class="bold mb-0 ellipsis">
                        {{ product.FundCode }}
                      </h3>
                      <h6 class="bold mb-0 ellipsis">
                        {{ product.InvestmentName }}
                      </h6>
                      <div class="m-0 size14 bold">
                        {{ formattedCurrency(product.Offer, "&#8358;") }}/unit
                      </div>
                      <div class="m-0 size12">
                        {{ product.ValueDate.substring(0, 10) }}
                      </div>
                    </div>
                  </section>
                </div>
              </div>

              {{}}
            </div>
            <div class="actions">
              <button
                type="button"
                class="nextStep w3-button w3-red w3-hover-orange"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="activeStep === 'GiftPurpose'"
        class="steps"
        data-step="GiftPurpose"
      >
        <div class="row">
          <div class="col-md-6 pb-3">
            <h3 class="my-0">Select a gift category</h3>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label">Category</label>
              <select
                name="GiftPurpose"
                v-model="gift.GiftPurpose"
                class="form-control form-control-lg max-width250"
              >
                <option
                  v-for="category in SETTINGS._GIFT_CATEGORY"
                  :key="category"
                  :value="category"
                >
                  {{ category }}
                </option>
              </select>
            </div>
            <div class="actions">
              <button
                type="button"
                class="prevStep w3-button w3-light-grey w3-hover-white mr-2"
              >
                Back
              </button>
              <button
                type="button"
                class="nextStep w3-button w3-red w3-hover-orange"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="activeStep === 'GiftAmount'"
        class="steps"
        data-step="GiftAmount"
      >
        <div class="row">
          <div class="col-md-6 pb-3">
            <h3 class="my-0">How much would you like to invest in gift?</h3>
            <div
              v-html="'E.g. ' + SETTINGS._CURRENCY + '2,500,000'"
              class="size14 mt-2"
            ></div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label size13">Gift Amount</label>
              <div class="input-group max-width250">
                <span
                  v-html="SETTINGS._CURRENCY"
                  class="input-group-text"
                ></span>
                <input
                  name="GiftAmount"
                  v-model="gift.GiftAmount"
                  class="form-control form-control-lg currency"
                />
              </div>
            </div>
            <div class="actions">
              <button
                type="button"
                class="prevStep w3-button w3-light-grey w3-hover-white mr-2"
              >
                Back
              </button>
              <button
                type="button"
                class="nextStep w3-button w3-red w3-hover-orange"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="activeStep === 'BenefFname'"
        class="steps"
        data-step="BenefFname"
      >
        <div class="row">
          <div class="col-md-6 pb-3">
            <h3 class="my-0">What is the Beneficiary's first name?</h3>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label size13">First Name</label>
              <input
                name="BenefFname"
                v-model="gift.BenefFname"
                class="form-control form-control-lg BenefFname"
              />
            </div>
            <div class="actions">
              <button
                type="button"
                class="prevStep w3-button w3-light-grey w3-hover-white mr-2"
              >
                Back
              </button>
              <button
                type="button"
                class="nextStep w3-button w3-red w3-hover-orange"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="activeStep === 'BenefSurname'"
        class="steps"
        data-step="BenefSurname"
      >
        <div class="row">
          <div class="col-md-6 pb-3">
            <h3 class="my-0">What is the Beneficiary's Surname?</h3>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label">Surname</label>
              <input
                name="BenefSurname"
                v-model="gift.BenefSurname"
                class="form-control form-control-lg BenefSurname"
              />
            </div>
            <div class="actions">
              <button
                type="button"
                class="prevStep w3-button w3-light-grey w3-hover-white mr-2"
              >
                Back
              </button>
              <button
                type="button"
                class="nextStep w3-button w3-red w3-hover-orange"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="activeStep === 'BenefEmail'"
        class="steps"
        data-step="BenefEmail"
      >
        <div class="row">
          <div class="col-md-6 pb-3">
            <h3 class="my-0">What is the beneficiary's email address?</h3>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label">Email address</label>
              <input
                name="BenefEmail"
                v-model="gift.BenefEmail"
                class="form-control form-control-lg BenefEmail"
              />
            </div>
            <div class="actions">
              <button
                type="button"
                class="prevStep w3-button w3-light-grey w3-hover-white mr-2"
              >
                Back
              </button>
              <button
                type="button"
                class="nextStep w3-button w3-red w3-hover-orange"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="activeStep === 'BenefPhoneNo'"
        class="steps"
        data-step="BenefPhoneNo"
      >
        <div class="row">
          <div class="col-md-6 pb-3">
            <h3 class="my-0">What is the beneficiary's telephone?</h3>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label">Telephone</label>
              <input
                name="BenefPhoneNo"
                v-model="gift.BenefPhoneNo"
                class="form-control form-control-lg BenefPhoneNo width200"
              />
            </div>
            <div class="actions">
              <button
                type="button"
                class="prevStep w3-button w3-light-grey w3-hover-white mr-2"
              >
                Back
              </button>
              <button
                type="button"
                class="nextStep w3-button w3-red w3-hover-orange"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="activeStep === 'PersonalMessage'"
        class="steps"
        data-step="PersonalMessage"
      >
        <div class="row">
          <div class="col-md-6 pb-3">
            <h3 class="my-0">
              Enter a personal message to accompany the gift voucher
            </h3>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <textarea
                name="PersonalMessage"
                v-model="gift.PersonalMessage"
                class="form-control form-control-lg PersonalMessage"
              ></textarea>
            </div>
            <div v-show="gift.Set_Reminder" class="form-group">
              <label class="control-label">Reminder Time</label>
              <div class="input-group width300">
                <select
                  name="Preffered_Time_hh"
                  v-model="gift.Preffered_Time_hh"
                  class="form-control form-control-lg width45p"
                >
                  <option v-for="i in 12" :key="'hh-' + i" :value="i">
                    {{ i > 9 ? i : "0" + i }}
                  </option>
                </select>
                <select
                  name="Preffered_Time_mm"
                  v-model="gift.Preffered_Time_mm"
                  class="form-control form-control-lg width45p"
                >
                  <option value="00">00</option>
                  <option v-for="i in 59" :key="'mm-' + i" :value="i">
                    {{ i > 9 ? i : "0" + i }}
                  </option>
                </select>
                <select
                  name="Preffered_Time_ampm"
                  v-model="gift.Preffered_Time_ampm"
                  class="form-control form-control-lg width10p"
                >
                  <option value="am">am</option>
                  <option value="pm">pm</option>
                </select>
              </div>
            </div>
            <div class="actions">
              <button
                type="button"
                class="prevStep w3-button w3-light-grey w3-hover-white mr-2"
              >
                Back
              </button>
              <button
                type="button"
                class="nextStep w3-button w3-red w3-hover-orange"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-show="activeStep === 'Payment'" class="steps" data-step="Payment">
        <div class="row equalHeightColumns">
          <div class="col-md-6 column w3-theme-d5">
            <div class="m-1 px-4 py-4 w3-round-large">
              <label class="control-label w3-text-red"> You are paying</label>
              <h3 class="mt-0">
                <span v-html="SETTINGS._CURRENCY"></span>{{ gift.GiftAmount }}
              </h3>
              <label class="control-label w3-text-red"> Gift Category</label>
              <h5 class="mt-0">
                {{ gift.GiftPurpose }}
              </h5>
              <label class="control-label w3-text-red mb-0">Beneficiary</label>
              <div class="mt-0">
                {{ gift.BenefSurname }} {{ gift.BenefFname }}
              </div>
              <label class="control-label w3-text-red mt-2 mb-0"
                >Beneficiary email</label
              >
              <div class="mt-0">
                {{ gift.BenefEmail }}
              </div>
              <label class="control-label w3-text-red mt-2 mb-0"
                >Beneficiary telephone</label
              >
              <div class="mt-0">
                {{ gift.BenefPhoneNo }}
              </div>
            </div>
            <div class="clear" style="clear: both"></div>
          </div>
          <div class="col-md-6 column">
            <div class="m-1 px-4 py-4">
              <h3 class="mt-0 mb-4">Purchase Gift Voucher</h3>

              <p>
                You will be prompted to provide your billing information for
                payment. Please note your transaction reference for this
                transaction
              </p>
              <p>Please click the button below to proceed</p>

              <div class="actions">
                <button
                  type="button"
                  class="
                    prevStep
                    w3-button
                    px-4
                    py-2
                    w3-light-grey w3-hover-white
                    mr-2
                  "
                >
                  Back
                </button>
                <button
                  type="submit"
                  class="w3-button px-4 py-2 w3-red w3-hover-orange"
                >
                  PROCEED
                </button>
              </div>
            </div>
            <div class="clear" style="clear: both"></div>
          </div>
          <div class="clear" style="clear: both"></div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import formatCurrency from "format-currency";
import "@dmuy/jquery-datepicker/duDatepicker.css";
import duDatepicker from "@dmuy/jquery-datepicker";
import $ from "jquery";
import axios from "axios";
import { ref, toRef, computed, onMounted, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { v4 as uuid } from "uuid";
import usePayments from "@/composables/use-payments";
import { formattedCurrency, backendURL } from "@/helpers/utilities";
export default {
  props: ["contactno", "email", "fullname", "phoneno", "products"],
  components: {},
  emits: ["closeGiftForm"],
  setup(props, { emit }) {
    const store = useStore();
    const title = ref("Purchase a gift voucher");
    const SETTINGS = computed(() => store.state.appSettings);
    const activeStep = ref("BenefProductCode");
    const ContactNo = toRef(props, "contactno");
    const EMail = toRef(props, "email");
    const PhoneNo = toRef(props, "phoneno");
    const Fullname = toRef(props, "fullname");
    const Products = toRef(props, "products");

    const gift = ref({
      TransRef: "",
      GiftAmount: "",
      GiftISerialNo: "",
      Token: "",
      GiftPurpose: "",
      BenefSurname: "",
      BenefFname: "",
      BenefEmail: "",
      BenefPhoneNo: "",
      BenefProductCode: "",
      PersonalMessage: "",
      PurchaserEmail: EMail.value,
      PurchaserPhoneNo: PhoneNo.value,
      PurchaserContactNo: ContactNo.value,
    });
    const makePayment = ref(false);
    const gateway = ref("paystack");
    const type = ref("gift");

    const GiftAmount = computed(() => {
      return gift.value.GiftAmount
        ? gift.value.GiftAmount.replace(/,/g, "")
        : 0;
    });

    const closeGiftForm = () => {
      emit("closeGiftForm");
    };

    const retry = ref(1);
    const PaymentSuccess = (data) => {
      if (data.Trx.apiCalled === 1) {
        gift.value.TransRef = "";
        store.dispatch("GiftsData");
        closeGiftForm();
        gift.value.ContributionAmount = 0;
      } else {
        gift.value.TransRef = data.Trx.PaymentRef;
        if (retry.value < 3) {
          retry.value++;
          IframeCallback(gift.value.TransRef, retry.value);
        } else {
          store.dispatch("hideIndicator");
        }
      }
    };
    const { loadIframe, closeIframe, IframeCallback } =
      usePayments(PaymentSuccess);

    const minAmount =
      SETTINGS.value._MIN_GIFT_AMOUNT ?? SETTINGS.value._MIN_INVESTMENT_AMOUNT;

    const Payment = () => {
      retry.value = 1;
      if (gift.value.TransRef) {
        IframeCallback(gift.value.TransRef);
        return;
      }
      if (!(GiftAmount.value > 0)) {
        store.dispatch("showAlert", {
          message: "Please enter a target gift amount",
          status: "error",
          showing: true,
        });
        return;
      }
      if (GiftAmount.value < minAmount) {
        store.dispatch("showAlert", {
          message:
            "Gift amount cannot be less than " +
            formattedCurrency(minAmount, "&#8358;"),
          status: "error",
          showing: true,
        });
        return;
      }

      if (!gift.value.GiftPurpose) {
        store.dispatch("showAlert", {
          message: "Please select a gift category",
          status: "error",
          showing: true,
        });
        return false;
      }
      if (!gift.value.BenefSurname) {
        store.dispatch("showAlert", {
          message: "Please enter beneficiary's surname",
          status: "error",
          showing: true,
        });
        return false;
      }

      if (!gift.value.BenefFname) {
        store.dispatch("showAlert", {
          message: "Please enter beneficiary's firstname",
          status: "error",
          showing: true,
        });
        return false;
      }

      if (!gift.value.BenefEmail) {
        store.dispatch("showAlert", {
          message: "Please enter beneficiary's email",
          status: "error",
          showing: true,
        });
        return false;
      }

      if (!gift.value.BenefPhoneNo) {
        store.dispatch("showAlert", {
          message: "Please enter beneficiary's telephone",
          status: "error",
          showing: true,
        });
        return false;
      }

      if (!gift.value.BenefProductCode) {
        store.dispatch("showAlert", {
          message: "Please select an investment type",
          status: "error",
          showing: true,
        });
        return false;
      }

      if (!gift.value.PersonalMessage) {
        store.dispatch("showAlert", {
          message: "Please enter a personal message",
          status: "error",
          showing: true,
        });
        return false;
      }

      store.dispatch("showIndicator");
      axios({
        method: "post",
        url: "/api/Gifts/AddNewGift",
        data: { ...gift.value },
      }).then((response) => {
        if (response.data.status === "success") {
          store.dispatch("hideIndicator");
          if (response.data.result) {
            store.dispatch("GiftsData");
            const GiftISerialNo = response.data.result.SerialNumber ?? null;
            const Token = response.data.result.Token ?? null;
            if (GiftISerialNo != null) {
              gift.value.GiftISerialNo = GiftISerialNo;
              gift.value.Token = Token;
              const form = $("#PaymentForm");
              if (gift.value) {
                for (const key in gift.value) {
                  if (Object.hasOwnProperty.call(gift.value, key)) {
                    const element = gift.value[key];
                    form.append(
                      '<input type="hidden" name="' +
                        key +
                        '" value="' +
                        element +
                        '" />'
                    );
                  }
                }
                form.attr(
                  "action",
                  backendURL + "/payment/" + gateway.value + "/" + type.value
                );

                if (gateway.value === "paystack") {
                  form.attr("target", "iframe");
                  loadIframe.value = true;
                }
                form.submit();
              }
            } else {
              store.dispatch("hideIndicator");
              closeGiftForm();
              store.dispatch("showAlert", {
                message: "A serial number error occured. Please try again",
                status: "error",
                showing: true,
              });
            }
          } else {
            store.dispatch("hideIndicator");
            store.dispatch("showAlert", {
              message: response.data.result,
              status: "error",
              showing: true,
            });
          }
        } else {
          store.dispatch("hideIndicator");
          store.dispatch("showAlert", {
            message: response.data.result,
            status: "error",
            showing: true,
          });
        }
      });
    };

    onBeforeMount(() => {
      store.dispatch("resetIdleTime");
    });
    onMounted(() => {
      $(".prevStep").on("click", function () {
        const parent = $(this).parents(".steps:first");
        const prev = parent.prev(".steps");
        if (prev.length) {
          $("div.steps").hide();
          prev.fadeIn();
        }
      });
      $(".nextStep").on("click", function () {
        const parent = $(this).parents(".steps:first");
        const next = parent.next(".steps");
        const step = parent.data("step");
        switch (step) {
          case "GiftAmount":
            if (!(GiftAmount.value > 0)) {
              store.dispatch("showAlert", {
                message: "Please enter a target gift amount",
                status: "error",
                showing: true,
              });
              return;
            }
            break;
          case "GiftPurpose":
            if (!gift.value.GiftPurpose) {
              store.dispatch("showAlert", {
                message: "Please select a gift category",
                status: "error",
                showing: true,
              });
              return false;
            }
            break;
          case "BenefSurname":
            if (!gift.value.BenefSurname) {
              store.dispatch("showAlert", {
                message: "Please enter beneficiary's surname",
                status: "error",
                showing: true,
              });
              return false;
            }
            break;

          case "BenefFname":
            if (!gift.value.BenefFname) {
              store.dispatch("showAlert", {
                message: "Please enter beneficiary's firstname",
                status: "error",
                showing: true,
              });
              return false;
            }
            break;

          case "BenefEmail":
            if (!gift.value.BenefEmail) {
              store.dispatch("showAlert", {
                message: "Please enter beneficiary's email",
                status: "error",
                showing: true,
              });
              return false;
            }
            break;

          case "BenefPhoneNo":
            if (!gift.value.BenefPhoneNo) {
              store.dispatch("showAlert", {
                message: "Please enter beneficiary's telephone",
                status: "error",
                showing: true,
              });
              return false;
            }
            break;

          case "BenefProductCode":
            if (!gift.value.BenefProductCode) {
              store.dispatch("showAlert", {
                message: "Please select an investment type",
                status: "error",
                showing: true,
              });
              return false;
            }
            break;

          case "PersonalMessage":
            if (!gift.value.PersonalMessage) {
              store.dispatch("showAlert", {
                message: "Please enter a personal message",
                status: "error",
                showing: true,
              });
              return false;
            }

            break;
        }

        if (next.length) {
          $("div.steps").hide();
          next.fadeIn();
        }
      });

      $(".currency").on("each", function () {
        gift.value[$(this).attr("name")] = formatCurrency($(this).val());
      });
      $(".currency").on("blur", function () {
        gift.value[$(this).attr("name")] = formatCurrency($(this).val());
      });
      $(".currency").on("focus", function () {
        gift.value[$(this).attr("name")] = $(this).val().replace(/,/g, "");
      });
    });
    return {
      title,
      gift,
      SETTINGS,
      activeStep,
      duDatepicker,
      Payment,
      Fullname,
      EMail,
      ContactNo,
      PhoneNo,
      closeGiftForm,
      uuid,
      loadIframe,
      closeIframe,
      Products,
      makePayment,
      gateway,
      type,
      PaymentSuccess,
      formattedCurrency,
    };
  },
};
</script>
<style scoped>
.steps {
  padding: 50px 40px;
  background-color: #fff;
}
.actions {
  margin-top: 20px;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #fff;
  opacity: 1;
}
</style>

